export const VISITED_EXPLORE_GUIDELINES_MODAL = 'VISITED_EXPLORE_GUIDELINES_MODAL'
export const COOKIES_POLICY_AGREEMENT = 'COOKIES_POLICY_AGREEMENT'
export const CODE_VERIFIER = 'CODE_VERIFIER'
